import { render, staticRenderFns } from "./PurchaseOrderBillsDetails.vue?vue&type=template&id=2d0ddb93&scoped=true"
import script from "./PurchaseOrderBillsDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderBillsDetails.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderBillsDetails.vue?vue&type=style&index=0&id=2d0ddb93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ddb93",
  null
  
)

export default component.exports